import styled from '@emotion/styled';

export const ShowMoreButtonWrapper = styled.div`
  margin-top: 40px;
  display: flex;
  align-items: center;

  p {
    margin-left: 20px;
  }
`;
